module.exports = " <div class=friend_list _v-bd9e526c=\"\"> <div v-for=\"fid of friendMapIndex | search\" class=friend @click=select(fid) :class=\"{ active: currentFriend === fid }\" _v-bd9e526c=\"\"> <avatar :src=friendMap[fid].avatar :username=resolveName(fid) size=1.5rem _v-bd9e526c=\"\"></avatar> <span class=nickname _v-bd9e526c=\"\">{{ resolveName(fid) }}</span> <i class=\"ext material-icons\" _v-bd9e526c=\"\">{{ friendMap[fid].shielded ? 'notifications_off' : 'notifications_none' }}</i> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-bd9e526c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/sidebar/FriendList.vue
 ** module id = 363
 ** module chunks = 2
 **/